import { Col, Row } from "antd";
import { MdArrowForward } from "react-icons/md";
import Logo from "../Assets/images/logo-mutual.svg";
import Button from "../Components/Button";
import Header from "../Components/Header";
import InfoBox from "../Components/InfoBox";
import Layout from "../Components/Layout";

function View({ isRenaultEmployee }) {
  return (
    <Layout>
      <Row justify="center">
        <Col xs={24} md={16} lg={16}>
          <div className="done__wrapper">
            <Header
              title={
                isRenaultEmployee
                  ? "Merci pour votre <b>confiance</b>"
                  : "Bienvenu à <b>Mobilité Mutuelle</b>"
              }
              subtitle="Terminé !"
              icon={
                <img
                  src={Logo}
                  alt="Mobilité Mutuelle"
                  className="done__wrapper--icon"
                />
              }
            />

            <InfoBox
              variant="success"
              shape="corner"
              text="Un email vous a été envoyé de la part de <b>Universign</b> avec l’ensembles des documents signés."
            />

            <Button
              width={300}
              alignment="center"
              type="primary-outlined"
              onClick={() => window.open("https://www.mobilite-mutuelle.fr/")}
            >
              <span>Découvrez tous nos services</span>
              <MdArrowForward size={16} />
            </Button>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default View;
